// getInitialProps runs server-side on first load and client-side on
// client-side navigations; "localhost" only resolves correctly server-side.
const apiBase = typeof window === 'undefined' ? 'http://localhost/api' : '/api';

export default apiBase;



// WEBPACK FOOTER //
// utils/apiBase.js